import React from "react";
import SinglePost from "../components/SinglePost";

export default function PageSinglePost() {
  return (
    <div>
      <main className="page">
        <SinglePost />
        <section className="h-32 w-full bg-white"></section>
      </main>
    </div>
  );
}
